export const server = "https://multi-vendor-backend-jjom.onrender.com/api/v2";

export const backend_url = "https://multi-vendor-backend-jjom.onrender.com/";
